export default __webpack_public_path__ + "static/media/download-icon.1cd45ca6.svg";